import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import { store, useAppSelector } from './store';
import { luminaLightTheme, luminaDarkTheme, GlobalStyles } from './theme';
import App from './App';

/**
 * Inner wrapper that reads the theme mode from Redux
 * and provides the matching styled-components theme.
 * Also sets the data-theme attribute on the HTML element
 * so that CSS custom properties switch between light/dark.
 */
const ThemedApp: React.FC = () => {
  const mode = useAppSelector((state) => state.theme.mode);
  const theme = mode === 'dark' ? luminaDarkTheme : luminaLightTheme;

  // Sync data-theme attribute for CSS custom properties
  React.useEffect(() => {
    document.documentElement.setAttribute('data-theme', mode);
  }, [mode]);

  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <App />
    </ThemeProvider>
  );
};

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <ThemedApp />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);
